import * as api from "../../shared/api";
import apiPath from "../../shared/apiPath";
import * as biz_data_helper from "../../shared/biz_data_helper";

const content_type = "SEI_VendTable";

const create = function () {
  return {
    content_type: "muji",
    age: 29
  };
};
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "20rem"
      }
    },
    {
      key: "AccountNum",
      label: "供应商帐户",
      sortable: true
    },
    {
      key: "EmailNotifier",
      label: "邮件通知人",
      thStyle: {
        width: "16rem"
      },
      sortable: true,
      editable: true
    },
    {
      key: "EmailContact",
      label: "联系人邮箱",
      type: "textarea",
      sortable: true,
      editable: true
    },
    {
      key: "VendGroup",
      label: "组",
      sortable: true
    },
    {
      key: "PaymTermId",
      label: "付款期限",
      sortable: true
    },
    {
      key: "Currency",
      label: "币种",
      sortable: true
    },
    {
      key: "PaymMode",
      label: "付款方式",
      sortable: true
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },
    {
      key: "PaymDayId",
      label: "付款日",
      sortable: true
    },
    {
      key: "Nationality_MX",
      label: "国籍",
      sortable: true
    },
    {
      key: "modifiedDateTime",
      label: "修改日期和时间",
      sortable: true,
      type: "datetime"
    }
  ],
  detail_fields: [
    {
      key: "dataAreaId",
      label: "公司",
      sortable: true
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "AccountNum",
      label: "供应商帐户",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "20rem"
      }
    },
    {
      key: "VendGroup",
      label: "组",
      sortable: true
    },
    {
      key: "PaymTermId",
      label: "付款期限",
      sortable: true
    },
    {
      key: "Currency",
      label: "币种",
      sortable: true
    },
    {
      key: "Blocked",
      label: "供应商暂停",
      sortable: true
    },
    {
      key: "DlvMode",
      label: "交货方式",
      sortable: true
    },
    {
      key: "PaymMode",
      label: "付款方式",
      sortable: true
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "PurchPoolId",
      label: "采购订单池",
      sortable: true
    },
    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },
    {
      key: "PaymDayId",
      label: "付款日",
      sortable: true
    },
    {
      key: "SegmentId",
      label: "细分市场",
      sortable: true
    },
    {
      key: "SubsegmentId",
      label: "子细分市场",
      sortable: true
    },
    {
      key: "Nationality_MX",
      label: "国籍",
      sortable: true
    },
    {
      key: "SEI_IsAllFrozen",
      label: "全部冻结",
      sortable: true
    },
    {
      key: "SEI_IsInvoiceFrozen",
      label: "发票冻结",
      sortable: true
    },
    {
      key: "createdBy",
      label: "创建人",
      sortable: true
    },
    {
      key: "createDateTime",
      label: "创建日期和时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "SEI_modifiedDateTime",
      label: "修改日期和时间",
      type: "datetime"
    }
  ]
};

const dataForm = {};

///前端验证
const rules = {};

const descriptor = {};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);
const methods = {
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
  //get item
  async getItemData(_params) {
    const item_biz_data = new biz_data_helper.base_entity_helper(
      "VendTable",
      create,
      descriptor
    );
    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.detail_fields, "key")
      })
      .run();
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
  ///get venditem by company
  async getItemOptions(_params) {
    const item_biz_data = new biz_data_helper.base_entity_helper(
      "VendTable",
      create,
      descriptor
    );
    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: [
          "id",
          "dataAreaId",
          "AccountNum",
          "SEI_Name",
          "SEI_modifiedDateTime"
        ]
      })
      .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
  async pickAndInvoke(params) {
    let result = await api.query_async({
      url: apiPath.axInterface.pickand_invoke,
      parameters: params,
      method: "get"
    });
    if (
      result &&
      result[0] &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.length > 0 &&
      result[0].result.data[0].status == 0
    ) {
      return result[0].result.data[0].data;
    } else {
      return null;
    }
  },
  ///保存sei供应商信息
  async saveData(_params) {
    let result = await biz_data
      .updateAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run();
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  }
};
export { biz_data, dataForm, fields, methods, rules };

